import { InjectionToken } from '@angular/core';
import { CwcInputTime } from '@cmx-web-components/angular';
import { Observable } from 'rxjs';

export type CxUiInputTimeFormat = CwcInputTime['format'];
export const CX_INPUT_TIME_FORMAT_TOKEN = new InjectionToken<CxUiInputTimeFormat | Observable<CxUiInputTimeFormat>>(
  'Token for providing input time format for Cemex components',
);

export type CxUiInputTimeControlButtons = CwcInputTime['controlButtons'];
export const CX_INPUT_TIME_CONTROL_BUTTONS_TOKEN = new InjectionToken<
CxUiInputTimeControlButtons | Observable<CxUiInputTimeControlButtons>>(
  'Token for providing input time control buttons for Cemex components',
);

export type CxUiInputTimeHideResetButton = CwcInputTime['hideResetButton'];
export const CX_INPUT_TIME_HIDE_RESET_BUTTON_TOKEN = new InjectionToken<
CxUiInputTimeHideResetButton | Observable<CxUiInputTimeHideResetButton>>(
  'Token for providing input time [hideResetButton] for cwc-input-time',
);

export type CxUiInputTimeLabelApply = CwcInputTime['labelApply'];
export const CX_INPUT_TIME_LABEL_APPLY_TOKEN = new InjectionToken<
CxUiInputTimeLabelApply | Observable<CxUiInputTimeLabelApply>
>('Token for providing cwc-input-date [labelApply] property');

export type CxUiInputTimeLabelCancel = CwcInputTime['labelCancel'];
export const CX_INPUT_TIME_LABEL_CANCEL_TOKEN = new InjectionToken<
CxUiInputTimeLabelCancel | Observable<CxUiInputTimeLabelCancel>
>('Token for providing cwc-input-date [labelCancel] property');
